import { gql } from '@apollo/client';

const GAME_ROOM_FIELDS = gql`
  fragment GameRoomFields on GameRoom {
    id
    code
    hostId
    status
    mode
    pack
    players {
      id
      userId
      score
      online
      user {
        id
        firstName
        lastName
      }
    }
    currentRound {
      id
      roundNumber
      status
      impostorId
      secretWord
      outcome
      clues {
        id
        playerId
        word
        order
      }
      votes {
        id
        voterId
        targetId
      }
    }
    rounds {
      id
      roundNumber
      status
      impostorId
      secretWord
      outcome
    }
  }
`;

export const FindGameRoom = gql`
  ${GAME_ROOM_FIELDS}
  query FindGameRoom($code: String!) {
    findGameRoom(code: $code) {
      ...GameRoomFields
    }
  }
`;

export const GameRoomById = gql`
  ${GAME_ROOM_FIELDS}
  query GameRoomById($roomId: String!) {
    gameRoomById(roomId: $roomId) {
      ...GameRoomFields
    }
  }
`;
